import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import { Box, Typography } from "@mui/material";
import { FC, useRef, useState } from "react";
import { PersonItemModel } from "../../../types/person-item.type";
import StyledWrapper from "./person-mobile.styles";

type Props = {
  imgList: string[];
  personList: PersonItemModel[];
  integratedType: "speakers" | "organizer";
};

const PersonMobile: FC<Props> = ({ personList, imgList, integratedType }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const touchStartX = useRef<number | null>(null);

  const handleNext = () => {
    setActiveIndex((prev) => (prev === personList.length - 1 ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? personList.length - 1 : prev - 1));
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 50) {
      if (dx < 0) handleNext();
      else handlePrev();
    }
    touchStartX.current = null;
  };

  const person = personList[activeIndex];
  const showDescription = person.hasDetails && !!person.description;

  return (
    <StyledWrapper onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      <Box className="mobile-image-row">
        <Box
          className={`mobile-arrow left ${integratedType}`}
          onClick={handlePrev}
          aria-label="previous"
        >
          <ArrowBackIosNewTwoToneIcon className={`arrow-icon ${integratedType}`} />
        </Box>
        <Box
          className="mobile-image"
          sx={{ backgroundImage: `url(${imgList[activeIndex]})` }}
        />
        <Box
          className={`mobile-arrow right ${integratedType}`}
          onClick={handleNext}
          aria-label="next"
        >
          <ArrowForwardIosTwoToneIcon className={`arrow-icon ${integratedType}`} />
        </Box>
      </Box>

      <Box className="mobile-name">
        <Box className="mobile-name-line">
          <Typography className={`mobile-firstname ${integratedType}`} variant="mainBlack">
            {person.firstName}
          </Typography>
          {person.lastName && (
            <Typography className={`mobile-lastname ${integratedType}`} variant="mainBlack">
              {person.lastName}
            </Typography>
          )}
        </Box>
        {person.role && (
          <Typography className={`mobile-role ${integratedType}`} variant="main">
            {person.role}
          </Typography>
        )}
      </Box>

      {showDescription && (
        <Box className="mobile-description-card">
          <Typography className="mobile-description" variant="main">
            {person.description}
          </Typography>
        </Box>
      )}
    </StyledWrapper>
  );
};

export default PersonMobile;
